<nav-header></nav-header>
              <jaspero-alerts></jaspero-alerts>
              <jaspero-confirmations></jaspero-confirmations>
              <simple-notifications></simple-notifications>
              <router-outlet></router-outlet>
              <app-footer></app-footer>


// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/app-layout.component.ts.AppLayoutComponent.html